import client from "../../zafclient";

const buildPlayerUrl = (src, name) => {
  const params = new URLSearchParams({
    view: "recording_player",
    src,
    name: name || "Recording",
  });
  return `${window.location.origin}/?${params.toString()}`;
};

const openRecordingModal = (src, name) => {
  if (!src) return;
  if (!client || typeof client.invoke !== "function") {
    window.open(src, "_blank", "noopener,noreferrer");
    return;
  }
  client
    .invoke("instances.create", {
      location: "modal",
      url: buildPlayerUrl(src, name),
      size: { width: "80vw", height: "80vh" },
    })
    .catch(() => {
      window.open(src, "_blank", "noopener,noreferrer");
    });
};

export default openRecordingModal;
